import classNames from 'classnames'
import * as React from 'react'

import {useIsAutodetectTimeZone} from '../../../../../hooks/useIsAutodetectTimeZone'
import {useDistanceToNow} from '../../../../../hooks/useTimeSelector'
import {parseDateToObj} from '../../../../../utils/dateTimeUtils'

import styles from './AgentLine.css'

const UPGRADE_MESSAGE = 'Agent has unregistered (will upgrade)'

function AgentLine(props: {
  className?: string
  isConnected?: boolean
  isAuthorized?: boolean
  lastActivityTime: string | null | undefined
  disconnectionComment: string | null | undefined
  isFirst?: boolean
  displayConnectionStatus?: boolean
}) {
  const {
    className,
    isConnected,
    isAuthorized,
    lastActivityTime,
    disconnectionComment,
    isFirst,
    displayConnectionStatus = false,
  } = props
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  const classes = classNames(styles.agentLine, className)
  const connectionStatusEl = (displayConnectionStatus || !isAuthorized) && (
    <span className={isConnected ? styles.connected : styles.disconnected}>
      {isConnected ? 'Connected' : 'Disconnected'}
      {disconnectionComment != null && ', '}
    </span>
  )
  const disconnectionCommentEl = disconnectionComment != null && ( // TODO: use flag from rest instead comparing strings
    <span className={disconnectionComment !== UPGRADE_MESSAGE ? styles.disconnected : undefined}>
      {disconnectionComment}
    </span>
  )
  const lastActive =
    lastActivityTime != null && parseDateToObj(lastActivityTime, isAutodetectTimeZone)
  const lastActiveFromNow = useDistanceToNow(lastActivityTime)
  return (
    <div className={classes}>
      <span className={styles.info}>
        {connectionStatusEl}
        {disconnectionCommentEl}
      </span>
      {lastActive && (
        <span
          title={lastActive.format('lll')}
          className={styles.lastActive}
          data-test="last-active"
        >
          {isFirst ? 'Last communication ' : ''}
          {lastActiveFromNow}
        </span>
      )}
    </div>
  )
}

export default AgentLine
